<template>
  <v-container>
    <v-row>
      <v-col md="9" sm="12" offset-md="1">
        <v-img
          class="mx-2 mb-16 ml-5"
          src="/img/logo.png"
          max-width="80"
        ></v-img>

        <v-spacer />
        <h1 class="mb-16 ml-5">Welcome...</h1>
        <v-spacer />

        <v-form class="ma-5">
          <v-alert
            v-if="$store.getters['Auth/error']"
            class="mb-2"
            text
            outlined
            color="warning"
            icon="mdi-alert"
          >
            {{ $store.getters["Auth/error"] }}
          </v-alert>

          <span class="text-uppercase font-weight-bold">Email</span>
          <v-text-field
            filled
            rounded
            dense
            type="email"
            name="email"
            placeholder="Enter Email Address"
            v-model="formData.email"
            :rules="rules.email"
            ref="email"
            class="mt-2"
          ></v-text-field>

          <span class="text-uppercase font-weight-bold">Password</span>
          <v-text-field
            filled
            rounded
            type="password"
            placeholder="*********"
            v-model="formData.password"
            :rules="rules.password"
            ref="password"
            dense
            class="mt-2"
          ></v-text-field>
          <p class="text-end">
            <router-link to="/auth/forgot-password"
              >forgot password?</router-link
            >
          </p>

          <v-btn @click="handleLogin" color="yellow" large rounded block
            >Login</v-btn
          >
        </v-form>
        <p class="font-weight-bold text-start mt-16 ml-5">
          Do you have an account?
          <router-link to="/auth/register">Sign up</router-link>
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Login",
  data: function() {
    return {
      formData: {
        email: "",
        password: ""
      }
    };
  },
  computed: {
    rules() {
      return {
        email: [
          value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || "Invalid e-mail.";
          }
        ],
        password: [value => !!value || "Required."]
      };
    }
  },
  methods: {
    handleLogin() {
      let isValid = true;

      for (let key in this.rules) {
        isValid = isValid ? this.$refs[key].validate(true) : false;
      }

      if (isValid) this.$store.dispatch("Auth/login", this.formData);
    }
  }
};
</script>

<style scoped></style>
